import { combineReducers } from 'redux';

import positions from './reducers/positionsReducer';
import framing from './reducers/framingReducer';
import alex from './reducers/alexReducer';
import curriculum from './reducers/curriculumReducer';

const messageInABottleCombinedReducers = combineReducers({
  positions,
  framing,
  alex,
  curriculum,
});

export default messageInABottleCombinedReducers;
